import { AdminFunnelPlatform, AdminFunnelStep, GetAdminFunnelStepResponse } from '@orbit/api-types'
import { useAdminFilter } from '@pages/Admin/AdminFilterContext'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

/**
 * Fetches one page of the devices and people behind a funnel step count
 * (GET /v1/admin/funnel/:step), for the same global date range and internal
 * toggle as {@link useAdminFunnel}. Disabled while `step` is null, i.e. the route
 * named no step, and the previous page stays on screen while the next one loads.
 * Gated server-side by the AdminGuard; non-admins receive 403.
 */
export const useAdminFunnelStep = (
	step: AdminFunnelStep | null,
	platform: AdminFunnelPlatform,
	page: number,
	pageSize: number,
) => {
	const { from, to, includeInternal } = useAdminFilter()

	return useQuery<GetAdminFunnelStepResponse>({
		queryKey: queryKeys.adminFunnelStep(step, from, to, platform, includeInternal, page, pageSize),
		queryFn: async () => {
			const response = await api.get<GetAdminFunnelStepResponse>(`/admin/funnel/${step}`, {
				params: {
					from,
					to,
					platform: platform === 'all' ? undefined : platform,
					page,
					pageSize,
					includeInternal: includeInternal || undefined,
				},
			})
			return response.data
		},
		enabled: step !== null,
		placeholderData: keepPreviousData,
	})
}
